import "bootstrap-icons/font/bootstrap-icons.css";
import { PrimaryButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { handleOpenPdf } from "utils";

import Financing from "assets/images/hero-images/Banner_Financing.png";
import BG from "assets/images/hero-images/BG.png";

function HistoricalTrend() {
  return (
    <div className="pf-page">
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Property Financing-i"
          title={`  <span className="jumbotron-subtitle-2">
                Historical Trend
              </span>      
              of Reference Rate Since January 2015
             `}
          buttonText="Let's connect! "
          backgroundImage={Financing}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3 className="general-header">About</h3>
          </div>
          <div className="col-xl-8">
            <p className="about-text">
              Published Standardised Base Rate (SBR), Base Rate (BR), Base
              Financing Rate (BFR) and Indicative Effective Financing Rate
              (IEFR)
            </p>
            <PrimaryButton text={"Historical Trend"} onClick={() => handleOpenPdf('https://www.alrajhibank.com.my/assets/pdf/personal-financing/Graph - Historical Trend of the Reference Rates-May23.pdf')} />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4 d-none d-xl-block">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default HistoricalTrend;
